$(document).ready(function () {

  $('[data-option-name="choose-a-cable-length"] .pro-options-main').each(function() {
    $(this).find('.pro-option').sort(function(a, b) {
        return +a.dataset.value - +b.dataset.value;
    }).appendTo(this);
  });
  
  
  function isInViewport(element) {
    var $element = $(element);
    var elementTop = $element.offset().top;
    var elementBottom = elementTop + $element.outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  }
    
  function scroll_stick_add_to_cart() {
    var addBtn = $('.pro-info-col .add-to-cart-button:visible');
    if(addBtn.length > 0){
      addBtn.removeClass("sticky-btn");
      var scroll = $(window).scrollTop();

      var elemTop = addBtn.offset().top;
      var elemBottom = elemTop + addBtn.height();

      if (!isInViewport('.pro-info-col .add-to-cart-button:visible')) {
        addBtn.addClass("sticky-btn");
      }
      // if (scroll >= elemBottom) {
      //   addBtn.addClass("sticky-btn");
      // }
    }
  }

  // scroll_stick_add_to_cart();

  // $(window).scroll(function() {    
  //   scroll_stick_add_to_cart();
  // });

  if ($('.top_pro_slider').length > 1) {
    $('.top_pro_slider').each(function(i, v) {
      var main_slider = $(this).find('.pro-slider-main')[0];
      var thumb_slider = $(this).find('.thumb_slider_main')[0];

      if (thumb_slider) {
        var thumb_pro_slider = new Swiper(thumb_slider, {
          slidesPerView: 6,
          watchSlidesProgress: true,
        });
        var pro_slider_main = new Swiper(main_slider, {
          navigation: {
            nextEl: ".sb_arrow_next",
            prevEl: ".sb_arrow_prev",
          },
          thumbs: {
            swiper: thumb_pro_slider,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          on: {
            transitionStart: function() {
              var videos = document.querySelectorAll('.pro-slider-main .video-slide');
              if (videos.length > 0) {
                Array.prototype.forEach.call(videos, function(video){
                  playPauseVideo(video, "pause");
                });
              }
            },
            
            transitionEnd: function() {
              if (document.querySelectorAll('.pro-slider-main .video-slide').length > 0) {
                var activeIndex = this.activeIndex;
                var activeSlide = document.querySelectorAll('.pro-slider-main .swiper-slide')[activeIndex];
                if (activeSlide.classList.contains('video-slide')) {
                  playPauseVideo(activeSlide, "play");
                  resizePlayer(iframes, 16/9);
                }
              }
            },
          }
        });
      } else {
        var pro_slider_main = new Swiper(main_slider, {
          navigation: {
            nextEl: ".sb_arrow_next",
            prevEl: ".sb_arrow_prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          on: {
            transitionStart: function() {
              var videos = document.querySelectorAll('.pro-slider-main .video-slide');
              if (videos.length > 0) {
                Array.prototype.forEach.call(videos, function(video){
                  playPauseVideo(video, "pause");
                });
              }
            },
            
            transitionEnd: function() {
              if (document.querySelectorAll('.pro-slider-main .video-slide').length > 0) {
                var activeIndex = this.activeIndex;
                var activeSlide = document.querySelectorAll('.pro-slider-main .swiper-slide')[activeIndex];
                if (activeSlide.classList.contains('video-slide')) {
                  playPauseVideo(activeSlide, "play");
                  resizePlayer(iframes, 16/9);
                }
              }
            },
          }
        });
      }
    })
  } else {
    if ($('.thumb_slider_main').length > 0) {
      var thumb_pro_slider = new Swiper(".thumb_slider_main", {
        slidesPerView: 6,
        watchSlidesProgress: true,
      });
      var pro_slider_main = new Swiper(".pro-slider-main", {
        navigation: {
          nextEl: ".sb_arrow_next",
          prevEl: ".sb_arrow_prev",
        },
        thumbs: {
          swiper: thumb_pro_slider,
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          transitionStart: function() {
            var videos = document.querySelectorAll('.pro-slider-main .video-slide');
            if (videos.length > 0) {
              Array.prototype.forEach.call(videos, function(video){
                playPauseVideo(video, "pause");
              });
            }
          },
          
          transitionEnd: function() {
            if (document.querySelectorAll('.pro-slider-main .video-slide').length > 0) {
              var activeIndex = this.activeIndex;
              var activeSlide = document.querySelectorAll('.pro-slider-main .swiper-slide')[activeIndex];
              if (activeSlide.classList.contains('video-slide')) {
                playPauseVideo(activeSlide, "play");
                resizePlayer(iframes, 16/9);
              }
            }
          },
        }
      });
    } else {
      var pro_slider_main = new Swiper(".pro-slider-main", {
        navigation: {
          nextEl: ".sb_arrow_next",
          prevEl: ".sb_arrow_prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        on: {
          transitionStart: function() {
            var videos = document.querySelectorAll('.pro-slider-main .video-slide');
            if (videos.length > 0) {
              Array.prototype.forEach.call(videos, function(video){
                playPauseVideo(video, "pause");
              });
            }
          },
          
          transitionEnd: function() {
            if (document.querySelectorAll('.pro-slider-main .video-slide').length > 0) {
              var activeIndex = this.activeIndex;
              var activeSlide = document.querySelectorAll('.pro-slider-main .swiper-slide')[activeIndex];
              if (activeSlide.classList.contains('video-slide')) {
                playPauseVideo(activeSlide, "play");
                resizePlayer(iframes, 16/9);
              }
            }
          },
        }
      });
    }
  }
  
  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command){    
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }
  
  // When the slide is changing
  function playPauseVideo(current, control){
    var currentSlide, slideType, startTime, player, video;
  
    currentSlide = $(current);
    slideType = currentSlide.attr("class").split(" ")[0];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");
  
    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if ((startTime != null && startTime > 0) && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value" : startTime
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value" : 1
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    } else if (slideType === "youtube") {
      switch (control) {
        case "play":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "mute"
          });
          postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {
      video = currentSlide.find("video").get(0);
      if (video != null) {
        if (control === "play"){
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }
  
  // Resize player
  function resizePlayer(iframes, ratio) {
    if (!iframes[0]) return;
    var win = $(".pro-slider-main"),
        width = win.width(),
        playerWidth,
        height = win.height(),
        playerHeight,
        ratio = ratio || 16/9;
  
    iframes.each(function(){
      var current = $(this);
      if (width / ratio < height) {
        playerWidth = Math.ceil(height * ratio);
        current.width(playerWidth).height(height).css({
          left: (width - playerWidth) / 2,
          top: 0
        });
      } else {
        playerHeight = Math.ceil(width / ratio);
        current.width(width).height(playerHeight).css({
          left: 0,
          top: (height - playerHeight) / 2
        });
      }
    });
  }
  
  //mobile products popup
  $('.pro-variant-row').on('scroll', function () {
    var leftPaddle = document.getElementsByClassName('arrow-left');
    var rightPaddle = document.getElementsByClassName('arrow-right');
    var itemsLength = $('.pro-variant-row .pro-variant').length;
    var itemSize = $('.pro-variant-row .pro-variant').outerWidth(true);
    var paddleMargin = 30;
    var getMenuWrapperSize = function () {
      return $('.pro-variant-row').outerWidth();
    }
    var menuWrapperSize = getMenuWrapperSize();
    var menuVisibleSize = menuWrapperSize;
    var getMenuSize = function () {
      return itemsLength * itemSize;
    };
    var menuSize = getMenuSize();
    var menuInvisibleSize = menuSize - menuWrapperSize;
    var getMenuPosition = function () {
      return $('.pro-variant-row').scrollLeft();
    };
    menuInvisibleSize = menuSize - menuWrapperSize;
    var menuPosition = getMenuPosition();
    var menuEndOffset = menuInvisibleSize - paddleMargin;
    // depending on scroll position
    if (menuPosition <= paddleMargin) {
      $(leftPaddle).addClass('unick-class');
      $(rightPaddle).removeClass('unick-class');
    } else if (menuPosition < menuEndOffset) {
      // show both paddles in the middle
      $(leftPaddle).removeClass('unick-class');
      $(rightPaddle).removeClass('unick-class');
    } else if (menuPosition >= menuEndOffset) {
      $(leftPaddle).removeClass('unick-class');
      $(rightPaddle).addClass('unick-class');
    }
    checkCurrentStep();
  });

  //Product Variant js
  function addButtonHtml(addButton, currentVariant, normalPrice, comparePrice) {
    var priceHtml = `<div class="product-price-div">
      <h3 class="sell-price">${Shopify.formatMoney(normalPrice)}</h3>
      ${normalPrice < comparePrice ? `<h3 class="compare-price">${Shopify.formatMoney(comparePrice)}</h3>` : ``}
    </div>`
    addButton.parents('[data-form]').find('[data-price]').html(priceHtml);
    var priceAboveHtml = `<span>${Shopify.formatMoney(normalPrice)}${normalPrice < comparePrice ? `<del>${Shopify.formatMoney(comparePrice)}</del>` : ``}</span>`
    $('.f-pro-price').html(priceAboveHtml);
    if (currentVariant == 'default') {
      var buttonHTML = `<span class="atc-content">${window.variantStrings.addToCart}</span>
      <span class="atc-price">${Shopify.formatMoney(normalPrice)}
        <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.08496 6.11816L13.3544 10.3876L9.08496 14.6571" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></path>
        </svg>
      </span>`
      addButton.prop('disabled', false);
      addButton.html(buttonHTML);
    } else {
      if (!currentVariant) {
        var buttonHTML = `<span class="atc-content">${window.variantStrings.unavailable}</span>
        <span class="atc-price">
          <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.08496 6.11816L13.3544 10.3876L9.08496 14.6571" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></path>
          </svg>
        </span>`
        addButton.prop('disabled', true);
        addButton.html(buttonHTML);
      } else {
        if (currentVariant.available) {
          var buttonHTML = `<span class="atc-content">${window.variantStrings.addToCart}</span>
          <span class="atc-price">${Shopify.formatMoney(normalPrice)}
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.08496 6.11816L13.3544 10.3876L9.08496 14.6571" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></path>
            </svg>
          </span>`
          addButton.prop('disabled', false);
          addButton.html(buttonHTML);
        } else {
          var buttonHTML = `<span class="atc-content">${window.variantStrings.soldOut}</span>
          <span class="atc-price">${Shopify.formatMoney(normalPrice)}
            <svg width="22" height="21" viewBox="0 0 22 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.08496 6.11816L13.3544 10.3876L9.08496 14.6571" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></path>
            </svg>
          </span>`
          addButton.prop('disabled', true);
          addButton.html(buttonHTML);
        }
      }
    }
  }

  var avi = {};
  
  function updateOption(form, selectorIndex) {
    switch (selectorIndex) {
      case 0:
        var key = 'root';
        var selector = form.find('[data-variant-option]:eq(0)');
        break;
      case 1:
        var key = form.find('[data-variant-option]:eq(0) input[type="radio"]:checked').val() || form.find('[data-variant-option]:eq(0) input[type="radio"].default').val();
        var selector = form.find('[data-variant-option]:eq(1)');
        break;
      case 2:
        var key = form.find('[data-variant-option]:eq(0) input[type="radio"]:checked').val() || form.find('[data-variant-option]:eq(0) input[type="radio"].default').val();  
        key += ' / ' + (form.find('[data-variant-option]:eq(1) input[type="radio"]:checked').val() || form.find('[data-variant-option]:eq(1) input[type="radio"].default').val());
        var selector = form.find('[data-variant-option]:eq(2)');
    }

    var initialValue = selector.find('input[type="radio"]:checked').val();
    var availableOptions = avi[key];
    if (typeof availableOptions !== "undefined") {
      form.find('[data-variant-option][data-index="' + selectorIndex + '"] .pro-option').each(function() {
        if ($.inArray($(this).find(':radio').val(), availableOptions) !== -1) {
          if (availableOptions.length == 1 && form.find('[data-variant-option][data-index="' + selectorIndex + '"]').prev().find('input:checked').length > 0) {
            $(this).removeClass('hidden').find(':radio').removeAttr('disabled').prop('checked', true);
            if ($(window).width() > 1025) {
              $(this).removeClass('hidden').find(':radio').trigger('click');
            }
          } else {
            $(this).removeClass('hidden').find(':radio').removeAttr('disabled');
          }
        }
        else {
          $(this).addClass('hidden').find(':radio').attr('disabled','disabled').prop('checked', false);
        }
      });
    }
    // if (selector.find('input[value="'+initialValue+'"]').parent().hasClass('soldout')) {
    //   selector.find('li:not(.soldout):eq(0) input').trigger('click');
    // } else {
    //   selector.find('input[value="'+initialValue+'"]').prop('checked', true); 
    // }
  };

  function unique(list) {
    var result = [];
    $.each(list, function(i, e) {
      if ($.inArray(e, result) == -1) result.push(e);
    });
    return result;
  }

  function linkOptionSelectors(product) {
    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (variant.available) {
        // Gathering values for the 1st drop-down.
        avi['root'] = avi['root'] || [];
        avi['root'].push(variant.option1);
        avi['root'] = unique(avi['root']);
        // Gathering values for the 2nd drop-down.
        if (variant.options.length > 1) {
          var key = variant.option1;
          avi[key] = avi[key] || [];
          avi[key].push(variant.option2);
          avi[key] = unique(avi[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (variant.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          avi[key] = avi[key] || [];
          avi[key].push(variant.option3);
          avi[key] = unique(avi[key]);
        }
      }
    }
  }

  function varaintSelect(form) {
    if (form.find('[type="application/json"]#product_data').length) {
      var mainProduct = $('[data-product]');
      var getVariantData = JSON.parse(form.find('[type="application/json"]#product_data').text());
      var fieldsets = form.find('[data-variant-option]').toArray();
      var addButtonAll = mainProduct.find('[data-add-to-cart-button]');
      var options = [];
  
      $.each(fieldsets, function (i, v) { 
        if ($(v).find('input[type="radio"]').is(':checked')) {
          var value = $(v).find('input[type="radio"]:checked').val();
          options.push(value);
        }
      });
      
      var currentVariant;
      
      $.each(getVariantData, function (i, variant) {
        var lll = 0;
        $.each(variant.options, function (index, option){ 
          if (options[index] !== option) {
            lll = 1;
          }
        });
        if (lll == 0) {
          currentVariant = variant;
        }
      });
  
      if (!currentVariant) {
        if (!addButtonAll.length) {
          return;
        }
        addButtonAll.each(function(i, addButton) {
          addButtonHtml($(addButton), currentVariant);
        });
      } else {
        console.log(currentVariant, 'currentVariant');
        window.selectedVariant = currentVariant;
        // window.history.replaceState({ }, '', url+'?variant='+currentVariant.id);


        if ($('.top_pro_slider').length > 1) {
          // var current_type = currentVariant.featured_image.alt;
          // var optionsKeys = ['option1', 'option2', 'option3'];
          // var current_type = optionsKeys.map(key => currentVariant[key]).filter(value => value.includes("Type"));
          // $('.top_pro_slider').addClass('hidden');
          // if ($('.top_pro_slider[data-group="'+current_type[0]+'"]').length) {
          //   $('.top_pro_slider[data-group="'+current_type[0]+'"]').removeClass('hidden');
          // } else {
          //   $('.top_pro_slider[data-group="default"]').removeClass('hidden');
          // }
        } else {
          if (currentVariant.featured_media) {
            var id = currentVariant.featured_media.id;
            var featuredSlide = $(pro_slider_main.el).find(`.swiper-slide[data-media-id="${id}"]`);
            if (featuredSlide.length > 0) {
              var index = featuredSlide.index();
              pro_slider_main.slideTo(index);
            }
          }
        }
        mainProduct.find('input[name="id"]').each(function() {
          $(this).val(currentVariant.id).trigger('chnage');
        });

        addButtonAll.each(function(i, addButton) {
          $(addButton).removeClass('select-option');
          mainProduct.find('.shopify-payment-button').show();
        });

        var normalPrice = currentVariant.price;
        var comparePrice = currentVariant.compare_at_price;
        var nonNullCheckedRadios = $('[data-accessories-option] input[type="radio"]:checked').filter(function() {
          return $(this).val() != '';
        });
        if (nonNullCheckedRadios.length) {
          var parent = $(nonNullCheckedRadios).parents('.pro-option');
          var getAccessoriesProductData = JSON.parse(parent.find('[type="application/json"]#accessories_product_data').text());
          normalPrice += getAccessoriesProductData.price;
          if (getAccessoriesProductData.compare_at_price) {
            comparePrice += getAccessoriesProductData.compare_at_price;
          }
        }
        // var priceHtml = `<h3 class="sell-price">${Shopify.formatMoney(normalPrice)}</h3>
        // ${currentVariant.price < currentVariant.compare_at_price ? `<h3 class="compare-price">${Shopify.formatMoney(comparePrice)}</h3>` : ``}`
        addButtonAll.each(function(i, addButton) {
          addButtonHtml($(addButton), currentVariant, normalPrice, comparePrice);
        });
      }
    }
  } 
  function checkCurrentStep() {
    var checkIndex = $(`.down_popup .pro-variant.active`).find('input[type="radio"]:checked').length;
    if (!$('.down_popup .pro-variant.active').is(':last-child')) {
      if (checkIndex == 0) {
        $('.pro-variant-main .arrow-right').addClass('unick-class');
      } else {
        $('.pro-variant-main .arrow-right').removeClass('unick-class');
      } 
    } else {
      $('.pro-variant-main .arrow-right').addClass('unick-class');
    }
    if ($('.down_popup .pro-variant.active').is(':first-child')) {
      $('.pro-variant-main .arrow-left').addClass('unick-class');
    } else {
      $('.pro-variant-main .arrow-left').removeClass('unick-class');
    }
  }

  function updateHeight() {
    $('.pro-variant').css('max-height','max-content');
    var VariantHeight = $('.pro-variant.active').outerHeight();
    var errortext = $('.pro-variant.active').find('.pro-error').length ? 0 : 0;
    $('.outer-variant-wpr').css('max-height',`${VariantHeight + 2 + errortext}px`);
    $('.pro-variant.active').css('max-height',`${$('.down_popup_wpr .pro-variant-main').outerHeight() + 2 + errortext}px`);
  }

  function stepWidth() {
    var proupVariantWidth = $('.down_popup .pro-variant-main');
    var variantLength = $('.down_popup .pro-variant-row').find('.pro-variant').length;
    $('.down_popup .pro-variant-row').find('.pro-variant').css('width',`${proupVariantWidth.outerWidth()}px`);
    $('.down_popup .pro-variant-row').css('width',`${proupVariantWidth.outerWidth() * variantLength}px`);
    updateHeight();
  }
  
  function openOption(cindex, duration, mindex) {
    // var bodyScrollVal = $(document).scrollTop();
    // $('body').css('--scroll-top',`-${bodyScrollVal}px`)
    var widthitem = $('.down_popup .pro-variant-main').outerWidth(); 
    $(".pro-variant-main .popup_arrows").attr('data-index', mindex)
    $(".pro-variant-row").css("transform",`translate3d(-${widthitem * cindex}px, 0px, 0px)`);
    $('.down_popup .pro-variant').removeClass('active');
    $(`.down_popup .pro-variant[data-index="${mindex}"]`).addClass('active');
    stepWidth()
    if (!$(".down_popup").hasClass("active")) {
      $(".down_popup").addClass("active"); 
    }
  }

  function progressBar(element) {
    var dataIndex = parseInt($(element).parents('.pro-variant').attr('data-index'));
    var VariantCheckIndex = $(element).parents('.pro-variant-row').find('.pro-variant').find('input[type="radio"]:checked').length;
    var ProgressSteps = 100 / $(element).parents('.pro-variant-row').find('.pro-variant').length;
    $('.down_popup .pro-variant').find('.pro-variant-progressbar .line').css("width", `${VariantCheckIndex * ProgressSteps }%`);
    $(element).parents('.pro-option').addClass('active').siblings('.pro-option').removeClass('active');
    var mainOption = $(element).parents('.pro-option').attr('for');
    $(`[data-option="${mainOption}"]`).addClass('selected').siblings('.pro-option').removeClass('selected');
    checkCurrentStep(dataIndex);
  }

  function checkStep(dataIndex) {
    var checkSelectedInput = $(`.down_popup .pro-variant[data-index="${dataIndex}"]`).find('input[type="radio"]:checked').length;
    // slideVal = parseInt($(`.down_popup .pro-variant.active`).attr('data-index')) + 1;
    if (dataIndex > 0) {
      $('.down_popup .pro-variant').each(function(index) {  
        if ($(this).find('input[type="radio"]:checked').length == 0) {
          if (index <= dataIndex) {
            var variantIndex = parseInt($(this).attr('data-index'));
            openOption(variantIndex, 0, variantIndex);
            checkCurrentStep();
            return false;
          } else {
            openOption(dataIndex, 0, dataIndex);
            checkCurrentStep();
            return false;
          }
        } else {
          openOption(dataIndex, 0, dataIndex);
          checkCurrentStep();
        }
      });
    } else {
      openOption(dataIndex, 0, dataIndex);
      checkCurrentStep();
    }
  }

  function updateDetails(form) {
    if ($('[data-selected-details]').length) {
      if ($('[data-selected-details] [data-type]').length) {
        var type = form.find('[data-option-name="choose-a-cable-type"] input:checked').val();
        $('[data-selected-details] [data-type]').html(type);
      }
      if ($('[data-selected-details] [data-length]').length) {
        var length = form.find('[data-option-name="choose-a-cable-length"] input:checked').val();
        $('[data-selected-details] [data-length]').html(length);
      }
      if ($('[data-selected-details] [data-speed]').length) {
        var speed = form.find('[data-option-name="choose-a-rated-power-charge-speed"] input:checked').val();
        $('[data-selected-details] [data-speed]').html(speed);
      }
      if ($('[data-selected-details] [data-addon]').length) {
        var addon = form.find('[name="accessories_products"]:checked').attr('data-name');
        $('[data-selected-details] [data-addon]').html(addon);
      }
    }
  }

  var slideVal = 1;
  function nextPrevStep(MoveSide) {
    var widthitem = $('.down_popup .pro-variant-main').outerWidth();  
     var avtiveIndex = parseInt($(".pro-variant-main .popup_arrows").attr('data-index'));
    if (MoveSide == 'next') {
      $(".pro-variant-row").css("transform",`translate3d(-${widthitem * (avtiveIndex)}px, 0px, 0px)`); 
      slideVal++;
    } else {  
      slideVal--;
      $(".pro-variant-row").css("transform",`translate3d(-${(widthitem * (avtiveIndex))}px, 0px, 0px)`);
    } 
    setTimeout(function() {
      updateHeight();
    }, 100);
  }

  $("body").on('click', '.pro-variant-main .arrow-left:not(.unick-class)', function (e) {
    e.preventDefault();
    var index = $(`.down_popup .pro-variant.active`).prev().attr('data-index');
    $('.down_popup .pro-variant').removeClass('active');
    $(`.down_popup .pro-variant[data-index="${index}"]`).addClass('active');
    $(".pro-variant-main .popup_arrows").attr('data-index', $(`.down_popup .pro-variant[data-index="${index}"]`).attr('data-index'))
    checkCurrentStep();
    nextPrevStep('prev');
  });
  
  $("body").on('click', '.pro-variant-main .arrow-right:not(.unick-class)', function (e) { 
    e.preventDefault();
    var index = $(`.down_popup .pro-variant.active`).next().attr('data-index');
    $('.down_popup .pro-variant').removeClass('active');
    $(`.down_popup .pro-variant[data-index="${index}"]`).addClass('active');
    $(".pro-variant-main .popup_arrows").attr('data-index', $(`.down_popup .pro-variant[data-index="${index}"]`).attr('data-index'))
    checkCurrentStep();
    nextPrevStep('next');
  });

  $('body').on('click', '.mob_info_col .pro-option', function() {
    var dataIndex = parseInt($(this).parents('.pro-variant').attr("data-index"));
    checkStep(dataIndex); 
  });
  
  $('body').on('click', '[data-select]', function() {
    var checkSelectedInput = $(this).parents('.pro-variant').find('input[type="radio"]:checked').length;
    if (checkSelectedInput) {
      if ($(this).parents('.pro-variant').next().length) {
        var dataIndex = $(this).parents('.pro-variant').next().attr("data-index");
        openOption(1, 0, dataIndex);
        checkCurrentStep();
        nextPrevStep('next');
      }
    } else {
      $('.pro-error').remove();
      $(this).parents('.pro-variant').append('<p class="pro-error">Please select the option</p>');
      setTimeout(function() {
        updateHeight();
      }, 100);
    }
  });

  $('body').on('click', '.down_popup .popup_overlay', function() {
    $(".down_popup").removeClass("active");
    setTimeout(function() {
      $(".pro-variant-row").css("transform",`translate3d(0px, 0px, 0px)`);
    }, 150);
  });

  $(window).on("load", function() {
    var form = $('.product_fm');
    var mainProduct = $('[data-product]');
    linkOptionSelectors(window.Product)
    mainProduct.find('[data-input-form]').each(function() {
      updateOption($(this), 0);
      updateOption($(this), 1);
      updateOption($(this), 2);
    });
  });

  $('body').on('change click', '[data-variant-option] input', function(e) {
    var target = event.target;
    var parent = $(this).parents('[data-variant-option]');
    parent.find('[data-selected-value]').html($(target).val());
    $('.pro-error').remove();
    var form = $(this).parents('[data-form]');
    updateDetails(form);
    parent.removeClass('selection_remains');
    if ($(window).width() < 1025) {
      progressBar(this);
      updateHeight();
      var checkSelectedInput = $(this).parents('.pro-variant').find('input[type="radio"]:checked').length;
      if (checkSelectedInput) {
        if ($(this).parents('.pro-variant').next().length) {
          var dataIndex = $(this).parents('.pro-variant').next().attr("data-index");
          openOption(1, 0, dataIndex);
          checkCurrentStep();
          nextPrevStep('next');
        }
      }
    }
    if (form.find('[data-variant-option] input[type="radio"]:checked').length > 0) {
      $('.clear-option-wrapper').show();
    } else {
      $('.clear-option-wrapper').hide();
    }
    if ($(this).parents('[data-variant-option]').attr('data-option-name') == 'choose-a-cable-type') {
      var current_type = $(this).val();
      $('.top_pro_slider').addClass('hidden');
      if ($('.top_pro_slider[data-group="'+current_type+'"]').length) {
        $('.top_pro_slider[data-group="'+current_type+'"]').removeClass('hidden');
      } else {
        $('.top_pro_slider[data-group="default"]').removeClass('hidden');
      }
    }
    if ($(this).parents('[data-variant-option]').attr('data-index') == 0) {
      updateOption(form, 1);
      updateOption(form, 2);
    }
    if ($(this).parents('[data-variant-option]').attr('data-index') == 1) {
      updateOption(form, 2);
    }
    if (form.find('[data-variant-option]').length == form.find('[data-variant-option] input[type="radio"]:checked').length) {
      varaintSelect(form);
    }
  });

  $('body').on('change', '[data-accessories-option] input', function(e) {
    var form = $(this).parents('[data-form]');
    var addButton = form.find('[data-add-to-cart-button]');
    var normalPrice = window.selectedVariant.price || 0;
    var comparePrice = window.selectedVariant.compare_at_price || 0;
    updateDetails(form);
    if ($(window).width() < 1025) {
      progressBar(this);
      updateHeight();
    }
    if ($(this).val() != '') {
      var parent = $(this).parents('.pro-option');
      var getAccessoriesProductData = JSON.parse(parent.find('[type="application/json"]#accessories_product_data').text());
      normalPrice += getAccessoriesProductData.price;
      comparePrice += getAccessoriesProductData.compare_at_price;
      addButtonHtml(addButton, window.selectedVariant, normalPrice, comparePrice);
    } else {
      normalPrice += 0;
      addButtonHtml(addButton, window.selectedVariant, normalPrice, comparePrice);
    }
  });

  $('body').on('click', '[data-clear]', function(e) {
    e.preventDefault();
    var mainProduct = $('[data-product]');
    var url = mainProduct.attr('data-url');
    var addButtonAll = mainProduct.find('[data-add-to-cart-button]');
    $('.clear-option-wrapper').hide();
    mainProduct.find('input[type="radio"]').prop('checked', false);
    addButtonAll.each(function(i, addButton) {
      $(addButton).addClass('select-option');
      mainProduct.find('.shopify-payment-button').hide();
    });
    mainProduct.find('[data-price]').html('');
    addButtonAll.each(function(i, addButton) {
      addButtonHtml($(addButton), 'default', 0);
    });
    linkOptionSelectors(window.Product)
    mainProduct.find('[data-input-form]').each(function() {
      updateOption($(this), 0);
      updateOption($(this), 1);
      updateOption($(this), 2);
    });
    window.history.replaceState({ }, '', url);
    if ($('.top_pro_slider').length > 1) {
      $('.top_pro_slider').addClass('hidden');
      $('.top_pro_slider[data-group="default"]').removeClass('hidden');
    }
    if ($(window).width() < 1025) {
      $('.down_popup .pro-variant').find('.pro-variant-progressbar .line').css("width", `0%`);
      mainProduct.find('.pro-option').removeClass('active');
      mainProduct.find('.pro-option').removeClass('selected');
      mainProduct.find('.pro-options-main .pro-option.on_default').addClass('selected');
    }
  });

  $('body').on('click', '[data-add-to-cart-button]', function() {
    var form = $(this).parents('[data-form]');
    $('.pro-error').remove();
    if ($(this).hasClass('select-option')) {
      var error = `<div class="pro-error">
        <div class="icons"><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.5306 7.53063L11.0603 10L13.5306 12.4694C13.6003 12.5391 13.6556 12.6218 13.6933 12.7128C13.731 12.8039 13.7504 12.9015 13.7504 13C13.7504 13.0985 13.731 13.1961 13.6933 13.2872C13.6556 13.3782 13.6003 13.4609 13.5306 13.5306C13.4609 13.6003 13.3782 13.6556 13.2872 13.6933C13.1961 13.731 13.0986 13.7504 13 13.7504C12.9015 13.7504 12.8039 13.731 12.7128 13.6933C12.6218 13.6556 12.5391 13.6003 12.4694 13.5306L10 11.0603L7.53063 13.5306C7.46095 13.6003 7.37822 13.6556 7.28718 13.6933C7.19613 13.731 7.09855 13.7504 7 13.7504C6.90146 13.7504 6.80388 13.731 6.71283 13.6933C6.62179 13.6556 6.53906 13.6003 6.46938 13.5306C6.3997 13.4609 6.34442 13.3782 6.30671 13.2872C6.269 13.1961 6.24959 13.0985 6.24959 13C6.24959 12.9015 6.269 12.8039 6.30671 12.7128C6.34442 12.6218 6.3997 12.5391 6.46938 12.4694L8.93969 10L6.46938 7.53063C6.32865 7.38989 6.24959 7.19902 6.24959 7C6.24959 6.80098 6.32865 6.61011 6.46938 6.46937C6.61011 6.32864 6.80098 6.24958 7 6.24958C7.19903 6.24958 7.3899 6.32864 7.53063 6.46937L10 8.93969L12.4694 6.46937C12.5391 6.39969 12.6218 6.34442 12.7128 6.3067C12.8039 6.26899 12.9015 6.24958 13 6.24958C13.0986 6.24958 13.1961 6.26899 13.2872 6.3067C13.3782 6.34442 13.4609 6.39969 13.5306 6.46937C13.6003 6.53906 13.6556 6.62178 13.6933 6.71283C13.731 6.80387 13.7504 6.90145 13.7504 7C13.7504 7.09855 13.731 7.19613 13.6933 7.28717C13.6556 7.37822 13.6003 7.46094 13.5306 7.53063ZM19.75 10C19.75 11.9284 19.1782 13.8134 18.1068 15.4168C17.0355 17.0202 15.5127 18.2699 13.7312 19.0078C11.9496 19.7458 9.98919 19.9389 8.09787 19.5627C6.20656 19.1865 4.46928 18.2579 3.10571 16.8943C1.74215 15.5307 0.813554 13.7934 0.437348 11.9021C0.061142 10.0108 0.254225 8.05042 0.992179 6.26884C1.73013 4.48726 2.97982 2.96451 4.58319 1.89317C6.18657 0.821828 8.07164 0.25 10 0.25C12.585 0.25273 15.0634 1.28084 16.8913 3.10872C18.7192 4.93661 19.7473 7.41498 19.75 10ZM18.25 10C18.25 8.3683 17.7661 6.77325 16.8596 5.41655C15.9531 4.05984 14.6646 3.00242 13.1571 2.37799C11.6497 1.75357 9.99085 1.59019 8.39051 1.90852C6.79017 2.22685 5.32016 3.01259 4.16637 4.16637C3.01259 5.32015 2.22685 6.79016 1.90853 8.3905C1.5902 9.99085 1.75358 11.6496 2.378 13.1571C3.00242 14.6646 4.05984 15.9531 5.41655 16.8596C6.77326 17.7661 8.36831 18.25 10 18.25C12.1873 18.2475 14.2843 17.3775 15.8309 15.8309C17.3775 14.2843 18.2475 12.1873 18.25 10Z" fill="currentColor"/></svg></div>
        <p>${window.variantStrings.selectionError}</p>
      </div>`;
      form.find('.pro-variant-main').after(error);
      $('.pro-main-row > .mob_info_col [data-variant-option]').removeClass('selection_remains');
      $('.pro-main-row > .mob_info_col [data-variant-option]').each(function() {
        var checkSelectedInput = $(this).find('input[type="radio"]:checked').length;
        if (checkSelectedInput == 0) {
          $(this).addClass('selection_remains');
          return false;
        }
      });
      $('.pro-main-row > .mob_info_col [data-variant-option]').each(function() {
        var checkSelectedInput = $(this).find('input[type="radio"]:checked').length;
        if (checkSelectedInput == 0) {
          $(this).find('[data-selected-value]').html('Please select');
        }
      });
    } else {
      var mainId = form.find('input[name="id"]').val();
      var items = [];
      items.push({
        quantity: 1,
        id: mainId
      });
      var nonNullCheckedRadios = form.find('[data-accessories-option] input[type="radio"]:checked').filter(function() {
        return $(this).val() != '';
      });
      $(this).addClass('loader');
      $(this).attr('disabled','disabled');
      if (nonNullCheckedRadios.length) {
        var accessorisId = $(nonNullCheckedRadios).val();
        items.push({
        quantity: 1,
          id: accessorisId
        });
      }
      addItemsToCart(items, false);
    }
  });
  
  // product recommended js
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(productRecommendationsSection);
    const url = productRecommendationsSection.dataset.url;
    fetch(url)
    .then(response => response.text())
    .then(text => {
      const html = document.createElement('div');
      html.innerHTML = text;
      const recommendations = html.querySelector('.product-recommendations');
      if (recommendations && recommendations.innerHTML.trim().length) {
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
        var swiper = new Swiper(".pro_view_slider .main_pro_des", {
          slidesPerView: 1,
          draggable: true,
          loop: false,
          scrollbar: {
            el: ".swiper-scrollbar",
            draggable: true,
          },
          navigation: {
            nextEl: ".sb_arrow_next",
            prevEl: ".sb_arrow_prev",
          },
          breakpoints: {
            1170: {
              slidesPerView: 3,
            },
            480:{
              slidesPerView: 2,
            }
          },
        });
      }
    })
    .catch(e => {
      console.error(e);
    });
  };
  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});
  observer.observe(productRecommendationsSection);

  //Size Guide Sidebar
  $('body').on('click', '[data-guide-popup]', function(event) {
    var guideValue = $(this).attr('data-guide-popup');
    $('.guide_drower, body').each(function() {
      if ($(this).attr('data-popup-guide') === guideValue) {
        $(this).addClass('active_drower');
        $('body').addClass('active_drower');
      }
    });
  });
  
  $('body').on('click', '.guide_drower_over, .close_icon', function () {
    $('.guide_drower, body').removeClass('active_drower');
  });

  $(".video-assembly-main video").each(function(index) {
    var $videoElement = $(this);
    var $playButton = $(".video-button-wap .video-play").eq(index); // Associate the play button with the correct video
    function togglePlay(videoElement) {
      if (videoElement[0].paused || videoElement[0].ended) {
        videoElement[0].play();
      } else {
        videoElement[0].pause();
      }
    }

    // Handle play button click for the specific video
    $playButton.on("click", function (e) {
      togglePlay($videoElement);
    });

    // Handle video click to pause/play the video and show the play button
    $videoElement.on("click", function (e) {
      if (!this.paused) {
        this.pause();
        $playButton.css("opacity", 1); // Show the play button
      }
    });

    // When the video is playing, hide the play button
    $videoElement.on("playing", function () {
      $playButton.css("opacity", 0); // Hide the play button
    });

    // When the video is paused, show the play button
    $videoElement.on("pause", function () {
      $playButton.css("opacity", 1); // Show the play button
    });
  });
});